export default () => {
  if (window['locationReloadOnceRunning']) {
    return;
  }

  window['locationReloadOnceRunning'] = true;

  window.location.reload();
};
